import React, { Component } from "react";
import TextField from "@material-ui/core/TextField";

class Form extends Component {
  state = {
    contact_name: "",
    contact_email: "",
    subject: "",
    message: "",
    to: "antonio@minervawebdevelopment.com",
    warning: false,
    success: false
  };

  handleChange = e => {
    let { value } = e.target;
    this.setState({ [e.target.name]: value, warning: false, success: false });
  };

  handleSubmit = e => {
    let { contact_name, contact_email, subject, message } = this.state;
    if (
      contact_email === "" ||
      contact_name === "" ||
      subject === "" ||
      message === ""
    ) {
      this.setState({ warning: true });
      return e.preventDefault();
    } else {
      setTimeout(() => {
        this.setState({
          contact_name: "",
          contact_email: "",
          subject: "",
          message: "",
          success: true
        });
      }, 1000);
    }
  };

  render() {
    return (
      <form
        action="https://minervawebdevelopment.com/contact-react/"
        method="POST"
        encType="multipart/form-data"
        target="invis"
      >
        {this.state.warning ? (
          <p className="alert alert-warning">All Fields Are Required</p>
        ) : null}
        {this.state.success ? (
          <p className="alert alert-success">
            Your email has been sent successfully!
          </p>
        ) : null}
        <div className="form-group">
          <TextField
            id="contact_name"
            name="contact_name"
            label="Name"
            value={this.state.contact_name}
            onChange={this.handleChange}
            margin="normal"
            className="input-group"
          />
          <TextField
            id="contact_email"
            name="contact_email"
            label="Email"
            type="email"
            value={this.state.contact_email}
            onChange={this.handleChange}
            margin="normal"
            className="input-group"
          />
          <TextField
            id="subject"
            name="subject"
            label="Subject"
            value={this.state.subject}
            onChange={this.handleChange}
            margin="normal"
            className="input-group"
          />
          <TextField
            id="message"
            label="Message"
            name="message"
            multiline
            rowsMax="6"
            value={this.state.message}
            onChange={this.handleChange}
            margin="normal"
            className="input-group"
          />
          <input name="to_email" type="hidden" value={this.state.to} />
          <input type="submit" name="submit-form" onClick={this.handleSubmit} />
        </div>
      </form>
    );
  }
}

export default Form;



// WEBPACK FOOTER //
// ./src/components/Form.js